<template>
	<div class="home">
		<div class="banner" @click="toLogin">
			<img src="./img/banner.png" alt="">
		</div>
		<h2 class="title">救援清单介绍</h2>
		<div class="container overflow">
			<img src="./img/jiantou.png" alt="">
			<div class="nav">
				<ul>
					<li :class="{active:prodectIndex == index}" @click="prodectIndex = index" v-for="(item,index) in prodectList">{{item}}</li>
				</ul>			
			</div>
			<img class="right" src="./img/jiantou.png" alt="">
		</div>
		<div class="container">
			<card :cardData=cardData v-show="prodectIndex == 0"></card>
			<card :cardData=cardData1 v-show="prodectIndex == 1"></card>
			<card :cardData=cardData2 v-show="prodectIndex == 2"></card>
			<card :cardData=cardData3 v-show="prodectIndex == 3"></card>
		</div>
		
	</div>
</template>

<script>
	import card from './card.vue'
	import cardData from './cardData.json'
	import cardData1 from './cardData1.json'
	import cardData2 from './cardData2.json'
	import cardData3 from './cardData3.json'
	export default {
		data(){
			return{
				cardData:[],//旅游专属
				cardData1:[],//个人
				cardData2:[],//企业
				cardData3:[],//银行专属
				prodectList:['旅行社专属救援清单','个人用户救援清单','企业救援清单','银行专属救援清单'],
				prodectIndex:0
			}
		},
		components: {
			card
		},
		methods:{
			toLogin(){
				this.$router.push({
					path:'/login',
					query:{status:1}
				})
			}
		},
		mounted(){
			this.cardData=cardData;
			this.cardData1=[];
			this.cardData2=[];
			this.cardData3=[];
		}
	}
</script>

<style scoped="scoped">
	.banner{min-height: 100px;background-color: #333;padding: 50px 0;}
	.banner img{width: 1200px;margin: 0 auto;display: block;cursor: pointer;}
	.title{text-align: center;padding: 30px;border-bottom: 1px solid #ccc;width: 300px;margin: 0 auto;position: relative;}
	.title:before{content: '';display: block;width: 100px;height: 4px;background: #00ABFA;position: absolute;bottom: 0;left: 100px;}
	.right{transform: rotate(180deg);}
	.container{padding: 20px 0;}
	.container img{float: left;cursor: pointer;margin-top: 11px;}
	.nav{float: left;}
	.container .nav{width: calc(100% - 32px);}
	.nav ul{padding: 0 10px;height: 50px;}
	.container ul li{float: left;line-height: 50px;padding: 0 30px;}
	.nav li{cursor: pointer;}
	.nav li.active{color: #00abfa;position: relative;}
	.nav li.active:before{content: '';display: block;background: url(img/button.png) left top no-repeat;width: 20px;height: 10px;background-size: 100% 100%;position: absolute;bottom: -5px;left: 50%;margin-left: -10px;}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue